import { Attribute } from './Attribute.js';

export const SN_LIST_ATTRIBUTE_TYPE = 'SnListAttribute';
export const SN_LIST_ATTRIBUTE_ID = 'MSISDN List';
export const LIST_LENGTH_ATTRIBUTE_PROPERTY_ID = 'List Length';

/**
 * @property {number} maxValues
 * @property {string[]} values
 * @property {boolean} isReadOnly
 */
export class SnListAttribute extends Attribute {
  constructor({ maxValues, values, previousValues = null, isReadOnly = false }) {
    super();
    this.maxValues = maxValues;
    this.values = values;
    this.previousValues = previousValues;
    this.isReadOnly = isReadOnly;
    this.type = SN_LIST_ATTRIBUTE_TYPE;
  }

  /**
   * @param {string[]} values
   */
  set values(values) {
    if (values.length < this.maxValues) {
      // fill missing SNs, so values array length is equal to maxLength
      this._values = values.concat(Array(this.maxValues - values.length).fill(''));
    } else {
      this._values = values;
    }
  }

  /**
   * @returns {string[]}
   */
  get values() {
    return this._values;
  }

  /**
   * @param {string[]|null} values
   */
  set previousValues(values) {
    if (!values) {
      this._previousValues = null;
    } else if (values.length < this.maxValues) {
      // fill missing SNs, so previousValues array length is equal to maxLength
      this._previousValues = values.concat(Array(this.maxValues - values.length).fill(''));
    } else {
      this._previousValues = values;
    }
  }

  /**
   * @returns {string[]|null}
   */
  get previousValues() {
    return this._previousValues;
  }

  hasAllowedNumberOfSns() {
    return this.values.length <= this.maxValues;
  }

  /**
   * Returns, if value on index is newly added value.
   * This can be used only for services in change state.
   *
   * @param {number} index
   * @return {boolean}
   */
  isAddedValue(index) {
    return this.previousValues !== null && this.values[index] && !this.previousValues[index];
  }

  /**
   * Returns, if value on index is removed value.
   * This can be used only for services in change state.
   *
   * @param {number} index
   * @return {boolean}
   */
  isRemovedValue(index) {
    return this.previousValues !== null && !this.values[index] && this.previousValues[index];
  }

  /**
   * Returns, if value on index is changed value.
   * This can be used only for services in change state.
   *
   * @param {number} index
   * @return {boolean}
   */
  isChangedValue(index) {
    return (
      this.previousValues !== null &&
      this.values[index] &&
      this.previousValues[index] &&
      this.values[index] !== this.previousValues[index]
    );
  }
}
